const Immutable = require('immutable')
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

class ConfirmModalRecord extends Immutable.Record({
  // Flags
  dismissOnBackdropClick: Boolean(),
  hasBackdrop: Boolean(true),
  hasCloseButton: Boolean(),
  // Values
  buttons: new Immutable.List(),
  heading: String(),
  subheading: String(),
  // Callbacks
  onConfirm: null // Function (NON-SERIALIZABLE!)
}) {
  // No methods
}

ConfirmModalRecord.reviver = keyedReviver(ConfirmModalRecord, {
  buttons: defaultReviver
})

ConfirmModalRecord.fromJS = function (obj) {
  return Immutable.fromJS(obj, ConfirmModalRecord.reviver)
}

ConfirmModalRecord.toJS = function () {
  throw new Error('ConfirmModalRecord is not serializable')
}

module.exports = ConfirmModalRecord
